module.exports = __webpack_public_path__ + "img/1.089c0cd2.jpg";